var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.CUSTOMER_FRAGMENT = (0, graphql_tag_1.default) `
  fragment CustomerFragment on Customer {
    id
    firstName
    lastName
    email
    phone
    acceptsMarketing
    tags
    defaultAddress {
      id
    }
  }
`;
//# sourceMappingURL=customerFragment.js.map